import React from "react";
import "./Header.css";
import logo from "./../../assets/img/Logo.jpg";

const Header = () => {
  return (
    <header className="header">
      <nav>
        <a href="/">
          <img src={logo} alt="Logo" />
        </a>
        <div className="navLinks">
          <a href="/photography">Photography</a>
          <div>&#183;</div>
          <a href="/coding">Coding</a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
